(function () {
    'use strict';

    angular.module("imApp").factory("offDutyCodesService", [function () {
        let service = {};

        return service;
    }]);
})();
